var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn_underline",on:{"click":_vm.goRefsList}},[_c('span',{staticClass:"btn_underline_label"},[_vm._t("default")],2),_c('div',{staticClass:"btn_underline_tabbed_line"})])}
var staticRenderFns = []

export { render, staticRenderFns }